import { apiClient } from '.';

// 큐레이션 강의 타입 정의
export interface RelatedLecture {
  relation_id: number;
  lecture_id: number;
  title: string;
  thumbnail_url: string;
  tags: string;
  lecturer_info: {
    id: number;
    email: string;
    name: string;
    department: string;
    image_url: string | null;
    tags: string[];
  };
}

export interface HomeLectureSection {
  home_lecture_section_id: number;
  title: string;
  text: string;
  related_lectures: RelatedLecture[];
}

export interface HomeCurationsResponse {
  code: number;
  status: string;
  message: string;
  data: HomeLectureSection[];
}

// 큐레이션 커피챗 타입 정의
export interface RelatedPerson {
  section_related_person_id: number;
  person_id: number;
  name: string;
  department: string;
  image_url: string;
  tags: string[];
}

export interface HomeCoffeeChatSection {
  coffee_chat_section_id: number;
  title: string;
  text: string;
  related_persons: RelatedPerson[];
}

export interface HomeCoffeeChatResponse {
  code: number;
  status: string;
  message: string;
  data: HomeCoffeeChatSection[];
}

// 홈 큐레이션 강의 목록 가져오기
export const fetchHomeCurations = async (): Promise<HomeCurationsResponse> => {
  try {
    const { data } = await apiClient.get<HomeCurationsResponse>(
      '/api/ui/home/curations/lectures/list',
      { withCredentials: true }
    );
    /// console.log('홈 큐레이션 강의 목록 조회 성공:', data);
    return data;
  } catch (error) {
    /// console.error('홈 큐레이션 강의 목록 조회 실패:', error);
    throw error;
  }
};

// 홈 큐레이션 커피챗 목록 가져오기
export const fetchHomeCoffeeChats = async (): Promise<HomeCoffeeChatResponse> => {
  try {
    const { data } = await apiClient.get<HomeCoffeeChatResponse>(
      '/api/ui/home/curations/coffee-chats/list',
      { withCredentials: true }
    );
    /// console.log('홈 큐레이션 커피챗 목록 조회 성공:', data);
    return data;
  } catch (error) {
    /// console.error('홈 큐레이션 커피챗 목록 조회 실패:', error);
    throw error;
  }
};